// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState, useRecoilValue } from 'recoil';

// Import Material UI
import AddIcon from "@material-ui/icons/Add";
import CreateIcon from "@material-ui/icons/Create";

// Import Pages
import { libraryIcons } from '../../autom/NewFlowLibraryAssetManager';
import AddNewVariables from "../../autom/leftSideBar/variables/addNewVariables/AddNewVariables";
import EditVariables from '../../autom/leftSideBar/variables/editVariables/EditVariables';
import ModuleItem from './ModuleItem/ModuleItem';
import LibraryItem from './LibraryItem/LibraryItem';
import ScopeLibraryItem from './ScopeLibraryItem/ScopeLibraryItem';

// Import Services
import LibraryService from '../../../../../services/LibraryService/LibraryService';
import VariableService from '../../../../../services/VariableService/VariableService';
// import { BASE_ORIGIN } from '../../../../../services/config';

// Import Icons
import VariableIcon from '../../../../../assets/icons/moduleIcons/variables-icon.svg';
import ApplicationIcon from '../../../../../assets/icons/moduleIcons/applications-icon.svg';
import AIicon from '../../../../../assets/icons/moduleIcons/ai-actions-icon.svg';
import UIicon from '../../../../../assets/icons/moduleIcons/ui-actions-icon.svg';
import AdvancedActionIcon from '../../../../../assets/icons/moduleIcons/advanced-actions-icon.svg';
import SearchIcon from '../../../../../assets/icons/search-icon.svg';


import IntegrationIcon from '../../../../../assets/icons/moduleIcons/Integration.svg';
import TransformIcon from '../../../../../assets/icons/moduleIcons/Transform.svg';
import UtilityIcon from '../../../../../assets/icons/moduleIcons/Utility.svg';
// Import Recoil
import { automModules, baseOrigin } from '../../../../../recoil-store/recoil-state';

// Import CSS
import './LeftArea.css';
import { Tooltip } from '@material-ui/core';

const defaultLibraryImg = `default_library.png`

const LeftArea = React.memo(({
    automType,
    handleDragEnd,
    handleDragStart,
    isEhFlow,
    variables,
    setVariables,
    openVariable,
    setOpenVariable,
    automVersionId,
    isDesktopRecorder,
    openAddActionsByClickDialog,
    mateId
}) => {
    const { t } = useTranslation();
    const setAutomModules = useSetRecoilState(automModules);

    const [categories, setCategories] = useState([]);
    const [variableSearch, setVariableSearch] = useState("");
    const [moduleSearch, setModuleSearch] = useState({});
    const [desktopRecorderActionsSearch, setDesktopRecorderActionsSearch] = useState("");
    const [variableType, setVariableType] = useState([]);
    const [getByVariables, setGetByVariables] = useState([]);
    const [refresh, setRefresh] = useState();
    const label = "CONTENT.FLOW.LEFT-AREA.";
    // const [baseOrigin, setBaseOrigin] = useState("");
    const [allLibraries, setAllLibraries] = useState([]);
    const base_origin = useRecoilValue(baseOrigin);

    useEffect(() => {
        //get all library dataasdsad
        async function fetchData() {
            // const baseOr = await BASE_ORIGIN;
            // setBaseOrigin(baseOr);
            const response = await LibraryService.getAllLibrary();
            if (response) {
                if (response?.status) {
                    let categoriesData = response.data;
                    if (automType === "Action") {
                        categoriesData = categoriesData.filter((category) => category.module_name !== "UI-ACTIONS")
                    }
                    categoriesData.forEach(category => {
                        category.expand = false;
                        category.libraries = category.libraries.filter(library => {
                            if (automType === "Action" && (!library.is_system || ["WHATSAPP", "MICROSOFT-TEAMS", "AUTOM-MATE"].includes(library.library_name))) {
                                library.expand = false;
                                library.visible = false;
                                return false
                            }
                            if (isEhFlow && category.module_name === "APPS" && ["DESKTOP-ACTIONS", "WHATSAPP", "MICROSOFT-TEAMS", "AUTOM-MATE"].includes(library.library_name)) {
                                library.expand = false;
                                library.visible = false;
                                return false
                            }
                            library.expand = false;
                            library.visible = true;
                            library.library_versions.find(item => item.is_active).actions.forEach(action => action.visible = true)
                            //library.actions.forEach(action => action.visible = true)
                            return true
                        })
                    });
                    setCategories(categoriesData);
                    // In order to add action with the + icon on the flow screen, the data withdrawn from the service is kept in 'recoil'.
                    setAutomModules(JSON.parse(JSON.stringify(categoriesData)));
                    if (isDesktopRecorder) {
                        combineAllLibraries(categoriesData)
                    }
                }
            }
        }

        fetchData().then(r => r);

        async function fetchVariableType() {
            let { data } = await VariableService.getVariableType();
            if (Array.isArray(data)) {
                if (automType === "Autom") {
                    data = data.filter(function (obj) {
                        return obj.name !== "app connector";
                    });
                }
                setVariableType(data)
            }
        }

        fetchVariableType().then(r => r);

    }, [refresh]);

    useEffect(() => {
        setRefresh(isEhFlow)
    }, [isEhFlow])

    const combineAllLibraries = (categoriesData) => {
        let libraryArray = []
        let oldLibraryLabel = []
        categoriesData && categoriesData.map((category) => {
            if (category.module_name === "ADVANCED-ACTIONS" || "APPS" || "UI-ACTIONS") {
                category.libraries && category.libraries.map((library) => {
                    if (!oldLibraryLabel.includes(library.library_label)) {
                        libraryArray.push(library)
                    }
                    oldLibraryLabel.push(library.library_label)
                })
            }
        })
        libraryArray.sort(function (a, b) {
            const nameA = a.library_label.toLowerCase();
            const nameB = b.library_label.toLowerCase();

            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        const newIndex = 0;
        const index = libraryArray.findIndex((element) => element.library_label === "DESKTOPACTIONS");
        if (index !== -1) {
            libraryArray.splice(newIndex, 0, libraryArray.splice(index, 1)[0]);
        }
        setAllLibraries(libraryArray)
    }

    const handleEditVariable = async (id, variable) => {
        if (!variable?.system_variable) {
            const { data } = await VariableService.getByVariable(id);
            if (typeof data === "object") {
                setGetByVariables(data);
            }
            setOpenVariable({ type: "edit", id: id })
        } else {
            // setGetByVariables(variable);
            // setOpenVariable({type: "edit", id: id})
        }
    }

    const filterBySearch = (searchTextOrj, i = undefined) => {
        let copySearch = { ...moduleSearch };
        copySearch[i] = searchTextOrj;
        setModuleSearch(copySearch);
        let copyCategories = [...categories];
        let category = copyCategories[i];
        let searchText = searchTextOrj.toLowerCase();

        // if (i === undefined) {
        //     setDesktopRecorderActionsSearch(searchText)
        //     searchText = searchText.replaceAll(' ', '');
        //     searchText = searchText.trim()

        //     let newAllLibraries = allLibraries
        //     newAllLibraries.forEach(library => {
        //         if (library.library_versions[library.library_versions.length - 1].actions) {
        //             if (searchText === "") {
        //                 library.expand = false;
        //                 library.visible = true;
        //                 library.library_versions[library.library_versions.length - 1].actions.forEach(action => action.visible = true)
        //             } else if (t("CONTENT.LIBRARY." + library.library_name + ".NAME")
        //                 .toLowerCase().includes(searchText)) {
        //                 library.expand = true;
        //                 library.visible = true;
        //                 library.library_versions[library.library_versions.length - 1].actions.forEach(action => action.visible = true)
        //             } else {
        //                 library.expand = false;
        //                 library.visible = false;
        //                 library.library_versions[library.library_versions.length - 1].actions.forEach(action => {
        //                     if (t(`CONTENT.LIBRARY.${library.library_name}.ACTION.${action.action_name}`).toLowerCase().includes(searchText)) {
        //                         library.expand = true;
        //                         library.visible = true;
        //                         action.visible = true;
        //                     } else action.visible = false;
        //                 })
        //             }
        //         }
        //     })
        //     setAllLibraries(...newAllLibraries)
        //     return
        // }
        category.libraries.forEach(library => {
            if (library.library_versions[library.library_versions.length - 1].actions) {
                if (searchText === "") {
                    library.expand = false;
                    library.visible = true;
                    library.library_versions[library.library_versions.length - 1].actions.forEach(action => action.visible = true)
                } else if (t("CONTENT.LIBRARY." + library.library_name + ".NAME")
                    .toLowerCase().includes(searchText)) {
                    library.expand = true;
                    library.visible = true;
                    library.library_versions[library.library_versions.length - 1].actions.forEach(action => action.visible = true)
                } else {
                    library.expand = false;
                    library.visible = false;
                    library.library_versions[library.library_versions.length - 1].actions.forEach(action => {
                        if (t(`CONTENT.LIBRARY.${library.library_name}.ACTION.${action.action_name}`).toLowerCase().includes(searchText)) {
                            const show = checkEnabledActions(library, action)
                            library.expand = show;
                            library.visible = show;
                            action.visible = show;
                        } else action.visible = false;
                    })
                }
            }
        })
        copyCategories[i] = category;
        setCategories([...copyCategories])
    }

    const checkEnabledActions = (library, action) => {
        if ((library.library_name === "DESKTOP-ACTIONS" && action.action_name !== "SCOPE" && !isDesktopRecorder) ||
            (library.library_name === "FILE" && ["OPEN", "PRINT"].includes(action.action_name)) ||
            (library.library_name === "PDF" && ["EXPORT-TO-EXCEL"].includes(action.action_name)) ||
            (isEhFlow && library.library_name === "ADVANCED-ACTIONS" && ["RUN-COMMAND"].includes(action.action_name))) {
            return false
        }
        return true
    }

    const filterDesktopActionsBySearch = (e) => {
        setDesktopRecorderActionsSearch(e)
        e = e.replaceAll(' ', '').trim().toLowerCase();

        let newAllLibraries = allLibraries
        let isAnyAction = []

        newAllLibraries.forEach((library) => {
            let isFindLibrary = false
            let isFindAction = false
            library.library_versions[library.library_versions.length - 1].actions.forEach(action => {
                let actionName = t(`CONTENT.LIBRARY.${library.library_name}.ACTION.${action.action_name}`)
                actionName = actionName.replaceAll(' ', '').trim().toLowerCase();
                if (!library.library_label.toLowerCase().includes(e) && !actionName.includes(e)) {
                    library.visible = false;
                }
                // if (!actionName.includes(e) && !(library.library_label === "DESKTOPACTIONS")) {
                //     action.visible = false;
                // }
                if (library.library_label === "DESKTOPACTIONS") {
                    isAnyAction.push(1)
                }

                if (library.library_label === "DESKTOPACTIONS" && !actionName.includes(e)) {
                    isAnyAction.pop()
                    action.visible = false
                }

                if (!actionName.includes(e) && !(library.library_label === "DESKTOPACTIONS")) {
                    action.visible = false;
                }
                // if (!actionName.includes(e)) {
                //     action.visible = false;
                // }


                else if (actionName.includes(e)) {
                    library.visible = true
                    action.visible = true
                    isFindLibrary = true
                    if (e.length >= 3) {
                        isFindAction = true
                    }
                }
                if (library.library_label.toLowerCase().includes(e)) {
                    library.visible = true;
                    action.visible = true
                }
            })
            if (isFindLibrary) {
                library.visible = true
                if (isFindAction) {
                    library.expand = true
                    return
                }
                library.expand = false
            }
            if (isAnyAction.length === 0 && library.library_label === "DESKTOPACTIONS") {
                library.library_versions[library.library_versions.length - 1].actions.forEach(action => {
                    action.visible = true
                })
            }
        })
        if (e) {
            setAllLibraries(newAllLibraries)
        }
    }

    const getIconByModuleName = (module_name) => {
        switch (module_name) {
            case 'APPS': // Integration
                return IntegrationIcon;
            case 'ADVANCED-ACTIONS': // Transform
                return TransformIcon;
            case 'AI-ACTIONS':
            case 'AGENTIC-AI':
                return AIicon;
            case 'UI-ACTIONS':
                return UIicon
            case 'UTILITIES':
                return UtilityIcon
            default:
                break;
        }
    }

    const getLearnLinkByModuleName = (module_name) => {
        // const docs = "https://docs.autommate.com/userguide/user-guide/build-flow/flow-components/";
        const docs = "https://docs.autommate.com/userguide/";
        switch (module_name) {
            case 'VARIABLES':
                return docs + "autom-features/variables";
            case 'APPS':
                return docs + "libraries/integration";
            case 'ADVANCED-ACTIONS':
                return docs + "libraries/transform";
            case 'AI-ACTIONS':
            case 'AGENTIC-AI':
                return docs + "libraries/agentic-ai"
            case 'UTILITIES':
                return docs + "libraries/utility";
            case 'UI-ACTIONS':
                return docs + "ui-actions";
            default:
                break;
        }
    }

    return (
        !isDesktopRecorder ?
            <div className='library-items-container'>
                {/* variable module start */}
                <ModuleItem icon={VariableIcon} title={t(label + "VARIABLES")} description={t(label + "VARIABLE-DESC")}
                    count={variables ? variables.length : 0} learnMoreLink={getLearnLinkByModuleName("VARIABLES")} >

                    {/* search section */}
                    <div className="variable-search-container m-b-14">
                        <div className="module-item-search variable-search-input">
                            <input value={variableSearch} className="module-item-search-text variable-module-search-text" placeholder={t(label + "SEARCH")}
                                onChange={(e) => setVariableSearch(e.target.value)} />
                        </div>
                        <div className='new-variable-section' onClick={() => setOpenVariable({ type: "open", id: "" })} >
                            <AddIcon className="new-variable-icon" />
                            <div>{t(label + "ADD-NEW")}</div>
                        </div>
                    </div>

                    {/* variable list section */}
                    {
                        variables?.filter(variable => {
                            if (variableSearch === '') {
                                return variable;
                            } else if (variable.name.toLowerCase().includes(variableSearch.toLowerCase())) {
                                return variable
                            }
                        }).map((variable, index) =>
                            <div className="variable-item-container" key={index}>
                                <Tooltip placement='top' title={variable.name}>
                                    <div className='variable-label-container'>
                                        <strong>[{variable.type}]</strong>
                                        <label className="variable-label">{variable.name}</label>
                                    </div>
                                </Tooltip>

                                {
                                    (variable.name !== "triggerParam" && variable.name !== "triggerHeader" && variable.name !== "triggerQuery") && !variable.system_variable && !variable.related_item_id ?
                                        <CreateIcon className="variable-edit-icon"
                                            onClick={() => handleEditVariable(variable.id, variable)} /> : ""
                                }
                            </div>
                        )
                    }

                </ModuleItem>
                {/* variable module end */}

                {
                    categories &&
                    categories.map((category, index) => (
                        <div key={category.id}>
                            <ModuleItem icon={getIconByModuleName(category.module_name)} title={t("CONTENT.AUTOMS-LIST." + category.module_name)} description={t(label + category.module_name + "-DESC")}
                                count={category.libraries ? category.libraries.length : 0} learnMoreLink={getLearnLinkByModuleName(category.module_name)} isEhFlow={isEhFlow} >
                                <div className="module-item-search m-b-14">
                                    <img className="module-item-search-icon" src={SearchIcon} alt="" />
                                    {/* <SearchIcon className="module-item-search-icon" /> */}
                                    <input value={moduleSearch[index] ? moduleSearch[index] : ''} className="module-item-search-text module-search-text" placeholder="Search"
                                        onChange={(e) => filterBySearch(e.target.value, index)} />
                                </div>
                                {category.libraries &&
                                    category.libraries.map((library, indexLib) => (
                                        library.visible &&
                                        <LibraryItem
                                            img={library.image?.includes('data:') ? library.image :
                                                `${base_origin}/libraries/${!library.image || library.is_system ? "system" : "custom"}/${library.image ? library.image : defaultLibraryImg}`
                                            }
                                            img_path={library.image?.includes('data:') ? '' :
                                                `/libraries/${!library.image || library.is_system ? "system" : "custom"}/${library.image ? library.image : defaultLibraryImg}`
                                            }
                                            name={library.library_label.includes('CUSTOM') ? library.library_name :
                                                t("CONTENT.LIBRARY." + library.library_name + ".NAME")}
                                            actions={library.library_versions[library.library_versions.length - 1].actions
                                                ?
                                                library.library_versions[library.library_versions.length - 1].actions :
                                                []
                                            }
                                            isEhFlow={isEhFlow}
                                            library={library}
                                            handleDragStart={handleDragStart}
                                            handleDragEnd={handleDragEnd}
                                            categoryModuleName={category.module_name}
                                            key={indexLib}
                                        />
                                    ))
                                }

                            </ModuleItem>
                        </div>
                    ))
                }
                {(openVariable?.type === "open" || openVariable === true) &&
                    <AddNewVariables setOpen={setOpenVariable} variableType={variableType} variables={variables}
                        setVariables={setVariables} automVersionId={automVersionId} mateId={mateId} />}
                {openVariable?.type === "edit" &&
                    <EditVariables setOpenVariables={setOpenVariable} variableTypeList={variableType}
                        setVariables={setVariables} getByVariables={getByVariables} />}
            </div>
            :
            <>
                <div className="module-item-search m-b-14">
                    <input style={{ position: "sticky" }} value={desktopRecorderActionsSearch} className="module-item-search-text module-search-text" placeholder="Search"
                        onChange={(e) => filterDesktopActionsBySearch(e.target.value)} />
                </div>

                {categories && allLibraries && allLibraries.map((library, indexLib) => (
                    <ScopeLibraryItem libraryExpand={library.expand} library={library} isDesktopRecorder={isDesktopRecorder} handleDragEnd={handleDragEnd} handleDragStart={handleDragStart} key={indexLib} openAddActionsByClickDialog={openAddActionsByClickDialog} />
                )
                )}
            </>
    )
})
export default LeftArea;
